"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PaddingDivider = props => {
  const {
    size,
    spacing
  } = props;
  let padding = '';
  if (size && !Number.isNaN(size.toString().trim())) {
    const pixels = parseInt(size.toString().trim(), 10);
    if (pixels > 0) {
      padding = 'pt-1';
    }
    if (pixels > 4) {
      padding = 'pt-2';
    }
    if (pixels > 8) {
      padding = 'pt-3';
    }
    if (pixels > 12) {
      padding = 'pt-4';
    }
    if (pixels > 16) {
      padding = 'pt-5';
    }
    if (pixels > 24) {
      padding = 'pt-6';
    }
  }
  if (size && Number.isNaN(size.toString().trim())) {
    padding = size;
  }
  if (!size) {
    padding = 'pt-6';
  }
  if (spacing) {
    padding = `pt-${spacing}`;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${padding} ${props.className || ''}`
  });
};
PaddingDivider.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.string,
  spacing: _propTypes.default.number
};
var _default = exports.default = PaddingDivider;
//# sourceMappingURL=PaddingDivider.js.map